<template>
  <Modal v-model="createGroupModal" width="500" :transfer="false" :mask-closable="false"
    :title="createGroupTitle" @on-visible-change="createGroupChange">
    <Form :model="createGroupForm" ref="createGroupForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row style="width: 90%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003238')" prop="groupName">
            <Input v-model.trim="createGroupForm.groupName" :placeholder="$t('key1003239')">
            </Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003240')" prop="remark">
            <Input v-model.trim="createGroupForm.remark" :autosize="{ minRows: 4, maxRows: 10}" type="textarea">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="createGroupModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="createGroupBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "createGroupModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      createGroupModal: false,
      createGroupTitle: '',
      createGroupForm: {
        groupName: '',
        remark: ''
      },
      ruleValidate: {
        groupName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003235'), trigger: 'blur'},
          {max: 20, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003236'), trigger: 'blur'}
        ]
      },
      groupType: 'add',
    };
  },
  methods: {
    // 初始化数据
    initGroupData(type, data) {
      let titleObj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003172'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003237')
      };
      this.createGroupTitle = titleObj[type];
      this.groupType = type;
      if (type === 'edit') {
        this.createGroupForm = data;
      }
      this.createGroupModal = true;
    },
    // 保存
    createGroupBtn() {
      let v = this;
      let methods = '';
      let url = '';
      let params = null;
      if (v.groupType === 'add') {
        methods = 'post';
        url = api.post_ymsMerchantGroup_insertYmsMerchantGroup;
        params = Object.assign({}, v.createGroupForm);
      } else {
        methods = 'put';
        url = api.put_ymsMerchantGroup_saveYmsMerchantGroup + '?type=1';
        let {groupName, remark, sortNo, ymsMerchantGroupId} = v.createGroupForm;
        params = [{
          groupName: groupName,
          remark: remark,
          sortNo: sortNo,
          ymsMerchantGroupId: ymsMerchantGroupId
        }];
      }
      v.$refs['createGroupForm'].validate((valid) => {
        if (valid) {
          v.axios[methods](url, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
              v.createGroupModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    createGroupChange(value) {
      if (!value) {
        this.$refs['createGroupForm'].resetFields();
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>